import React from "react";
import Constants from "../../../constants/Index";

type CapacityLegendProps = {
  view: "immediate" | "average";
  maxCapacity: number;
};

export function CapacityLegend({ view, maxCapacity }: CapacityLegendProps) {
  const isVisible = Number.isFinite(Number(maxCapacity)) && Number(maxCapacity) > 0;
  
  const formatNumber = (num: number) => {
    return num % 1 === 0 ? num.toString() : num.toFixed(2);
  };
  
  if (!isVisible) return null;

  return (
    <section className="capacitybvroute__barnumber--container">
      <strong className="capacitybvroute__barnumber--title">
        {view === "average" ? 'LOTAÇÃO MÉDIA (UA/HA)' : 'LOTAÇÃO INSTANTÂNEA (UA/HA)'}
      </strong>
      <div className="capacitybvroute__barnumber--bar" />
      <div className="capacitybvroute__barnumber--containerlegend">
        {view === "average" ? (
          <>
            <span>0,00</span>
            <span>1,00</span>
            <span>2,00</span>
            <span>3,00</span>
            <span>4,00</span>
            <span>5,00</span>
            <span>6,00</span>
            <span>7,00</span>
            <span>8,00</span>
          </>
        ) : (
          <>
            <span>0,00</span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span>{formatNumber(Number(maxCapacity))}</span>
          </>
        )}
      </div>
    </section>
  );
}
